import React from 'react';
import { BellIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface NotificationButtonProps {
  hasNotification?: boolean;
}
export const NotificationButton = ({
  hasNotification = true
}: NotificationButtonProps) => {
  const navigate = useNavigate();
  return <button onClick={() => navigate('/chat/notification-alert')} className="relative w-4 h-4 flex items-center justify-center group" title="View notification" data-id="element-139">
      {hasNotification && <>
          <div className="w-2.5 h-2.5 bg-[#ff4444] rounded-full shadow-[0_0_10px_rgba(255,68,68,0.5)]" data-id="element-140"></div>
          <div className="absolute inset-0 w-full h-full bg-[#ff4444] rounded-full animate-ping opacity-75" data-id="element-141"></div>
        </>}
    </button>;
};